import { InjectorService } from '../classes/injector-service.js';

/**
 * 类装饰器，用于标记一个类为可注入的
 * 使用该装饰器后，其他 Invokable 类中才可注入此类
 *
 * @param options - 注入选项
 * @public
 */
function Injectable(options) {
    return function (target) {
        InjectorService.set(Object.assign(Object.assign({ provide: target }, options), { useClass: target }));
        return target;
    };
}

export { Injectable };
//# sourceMappingURL=injectable.js.map
